export const baseStyles = {
  padding: "4px 10px",
  borderRadius: "6px",
  fontSize: "12px",
  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  height: "auto",
  lineHeight: "normal",
  alignSelf: "center",
  whiteSpace: "nowrap",
};

export const statusConfig = {
  open: {
    text: "Conectado",
    style: {
      backgroundColor: "#E9F5E3",
      color: "#82BD69",
    },
  },

  PENDING:
  {
    text: "Em análise",
    style: {
      backgroundColor: "#F6EDCB",
      color: "#DEA73F",
    },
  },
  APPROVED: {
    text: "Disponível",
    style: {
      backgroundColor: "#E9F5E3",
      color: "#82BD69",
    },
  },

  Desconectado: {
    text: "Desconectado",
    style: {
      backgroundColor: "#FCEAE7",
      color: "#E98A83",
    },
  },

  PROCESSING: {
    text: "Processando",
    style: {
      backgroundColor: "#E6F0FF",
      color: "#2F6FED",
    },
  },

  pending: {
    text: "Pendente",
    style: {
      backgroundColor: "#F6EDCB",
      color: "#DEA73F",
    },
  },

  Erro: {
    text: "Falha",
    style: {
      backgroundColor: "#FCEAE7",
      color: "#E98A83",
    },
  },

  ERROR: {
    text: "Falha",
    style: {
      backgroundColor: "#FCEAE7",
      color: "#E98A83",
    },
  },
};
